<app-service-detail #detail [context]="context" [location]="'Templates'">
    <div class="container-fluid px-md-5 px-3">
        <tab-menu
            class="templates-tab-menu"
            *ngIf="tabBaseUrl"
            [items]="tabs"
            [baseUrl]="tabBaseUrl"
            [subMenu]="false">
        </tab-menu>
        <div class="templates-content">
            <messages-table
                *ngIf="isActive('messages')"
                [useServiceDetailWrapper]="false">
            </messages-table>
            <app-doc-builder
                *ngIf="isActive('certificates')"
                [useServiceDetailWrapper]="false"
                [context]="context"
                [serviceId]="serviceId"
                [parentServiceDetail]="detail"
                [pageLocation]="'Templates'">
            </app-doc-builder>
        </div>
    </div>
</app-service-detail>
